export default __webpack_public_path__ + "media/src/features/footer/assets/instagram@2x-72487e378eddf8bdb822b8b4a345209b.png";